$(document).on("gform_confirmation_loaded", function (e, form_id) {

	//if(form_id == 2) {

		ga('send', {
		  hitType: 'event',
		  eventCategory: 'Contact Form',
		  eventAction: 'Click',
		  eventLabel: window.location.href
		});

	//}

});


